<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <span class="fw-bold">
        {{ metricas.top_clientes.titulo }}
      </span>
      <small class="text-muted" v-if="clients && clients.length">
        {{ clients.length }} clientes
      </small>
    </div>
    <div class="card-body p-0">
      <div class="table-responsive" style="height: 500px">
        <table class="table table-hover mb-0 align-middle">
          <thead class="table-light">
          <tr>
            <th style="width: 52px;"></th>
            <th>Cliente</th>
            <th class="text-end" title="Quantidade de produtos distintos comprados">Mix</th>
            <th class="text-end">Pedidos</th>
            <th class="text-end">Total</th>
            <th class="text-end" title="Representatividade em relação ao total vendido no período">%</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in clients" :key="item.cliente_id">
            <td>
              <!-- avatar simples -->
              <div
                  class="rounded-circle bg-light border d-flex align-items-center justify-content-center"
                  style="width: 42px; height: 42px; font-size: 0.75rem;"
              >
                {{ getInitials(item.nome_cliente) }}
              </div>
            </td>
            <td>
              <div class="fw-semibold">{{ item.nome_cliente || ('ID ' + item.cliente_id) }}</div>
              <div class="small text-muted">
                Ticket médio: {{ formatMoney(item.ticket_medio) }}
              </div>
              <div class="small">
                <span class="badge bg-secondary me-1">B2B: {{ item.qtd_pedidos_b2b || 0 }}</span>
                &nbsp;
                <span class="badge bg-secondary me-1">CC: {{ item.qtd_pedidos_callcenter || 0 }}</span>
                &nbsp;
                <span class="badge bg-secondary">FV: {{ item.qtd_pedidos_forca_vendas || 0 }}</span>
              </div>
            </td>
            <td class="text-end">
              {{ formatNumber(item.mix) }}
            </td>
            <td class="text-end">
              {{ formatNumber(item.qtd_pedidos) }}
            </td>
            <td class="text-end">
              {{ formatMoney(item.total_comprado) }}
              <div class="small text-muted mt-1">
                <span class="badge bg-secondary me-1">B2B: {{ formatMoney(item.total_comprado_b2b) }}</span><br>
                <span class="badge bg-secondary me-1">CC: {{ formatMoney(item.total_comprado_callcenter) }}</span><br>
                <span class="badge bg-secondary me-1">FV: {{ formatMoney(item.total_comprado_forca_vendas) }}</span>
              </div>
            </td>
            <td class="text-end" title="Representatividade em relação ao total vendido no período">
              {{ formatPercent(item.representatividade_percentual) }}
            </td>
          </tr>
          <tr v-if="!clients || !clients.length">
            <td colspan="6" class="text-center py-4 text-muted">
              Nenhum cliente encontrado no período.
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopClientes",
  props: ["metricas"],
  computed: {
    clients () {
      return this.metricas?.top_clientes?.metricas || [];
    }
  },
  methods: {
    formatMoney(value) {
      const num = Number(value) || 0;
      return num.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    },
    formatNumber(value) {
      const num = Number(value) || 0;
      return num.toLocaleString("pt-BR");
    },
    formatPercent(value) {
      const num = Number(value) || 0;
      return num.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + "%";
    },
    getInitials(name) {
      if (!name) return "CL";
      const parts = name.trim().split(" ");
      if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    }
  }
};
</script>

<style scoped>
.table td,
.table th {
  vertical-align: middle;
}
.badge {
  font-weight: 500;
}
</style>
